import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import AddCityComponent from '../../components/AddCityComponent/AddCityComponent'

const AddCity = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <AddCityComponent/>
                </div>
            </div>
        </div>
    )
}

export default AddCity
